/**
 * Convert a full name to 2-letter abbreviation by taking the first letter of the first and last part of the name and capitalising
 * @param name full name
 */
export function nameToTwoLetterAbbreviation(name: string): string {
  const parts = name.split(" ")
  if (parts.length == 0)
    return parts[0].charAt(0).toUpperCase()
  return parts[0].charAt(0).toUpperCase() + parts[parts.length-1].charAt(0).toUpperCase()
}